import { render, staticRenderFns } from "./article-card.vue?vue&type=template&id=4af08b21&scoped=true&"
import script from "./article-card.vue?vue&type=script&lang=js&"
export * from "./article-card.vue?vue&type=script&lang=js&"
import style0 from "./article-card.vue?vue&type=style&index=0&id=4af08b21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af08b21",
  null
  
)

export default component.exports